import React, {
  CSSProperties,
  HTMLProps,
  useEffect,
  useRef,
  useState
} from 'react';
import { CaptionText, InputLabel, InputText, Wrapper } from './StyledTextInput';

export interface ITextInputProps extends HTMLProps<HTMLInputElement> {
  value: string;
  caption?: string;
  counter?: boolean;
  maxLength?: number;
  inlineStyle?: CSSProperties;
}

const TextInput: React.FC<ITextInputProps> = ({
  id,
  placeholder,
  onBlur,
  onFocus,
  caption,
  value,
  counter = false,
  maxLength,
  ...rest
}) => {
  const [active, setActive] = useState(value && value.length > 0);
  const textRef = useRef<HTMLInputElement | null>(null);

  const handleOnFocus = event => {
    setActive(true);

    if (textRef.current) {
      textRef.current?.focus();
    }

    if (onFocus) {
      onFocus(event);
    }
  };

  const handleOnBlur = event => {
    setActive(event.target.value.length !== 0);

    if (onBlur) {
      onBlur(event);
    }
  };

  useEffect(() => {
    setActive(textRef.current?.value?.length !== 0);
  }, [value]);

  const counterText =
    !counter || !value
      ? ''
      : `${value.length} ${maxLength ? `/ ${maxLength}` : ''} Characters`;

  return (
    <Wrapper>
      {/* @ts-ignore */}
      <InputText
        id={id}
        placeholder={placeholder}
        active={active || undefined}
        onBlur={handleOnBlur}
        onFocus={handleOnFocus}
        ref={textRef}
        value={value}
        maxLength={maxLength}
        {...rest}
      />
      <InputLabel htmlFor={id} active={active}>
        {placeholder}
      </InputLabel>
      {caption && <CaptionText>{caption}</CaptionText>}
      {counterText && <CaptionText>{counterText}</CaptionText>}
    </Wrapper>
  );
};

export default TextInput;
